
<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import * as R from 'ramda'
import ColumnsMixin from '../mixins/columns'
import singleActionsMixin from '../mixins/singleActions'
import { getNameFilter, getDescriptionFilter } from '@/utils/common/tableFilter'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'LicenseList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, singleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: [Function, Object],
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'licenserecords',
        getParams: this.getParam,
        filterOptions: {
          id: {
            label: this.$t('table.title.id'),
            filter: true,
            formatter: val => {
              return `id.contains(${val})`
            },
          },
          licensee: getNameFilter({ label: this.$t('scope.text_318'), field: 'licensee' }),
          description: getDescriptionFilter(),
          service_num: {
            label: this.$t('scope.text_778'),
            filter: true,
            formatter: val => {
              return `service_num.contains(${val})`
            },
          },
          expire: {
            label: this.$t('scope.text_798'),
            dropdown: true,
            items: [
              { label: this.$t('scope.text_800'), key: 'failure' },
              { label: this.$t('scope.text_799'), key: 'effective' },
              { label: this.$t('scope.cancelled'), key: 'cancelled' },
            ],
            filter: true,
            formatter: val => {
              if (val && val.length > 0) {
                const now = this.$moment().format()
                if (val[0] === 'failure') {
                  return [`expire.lt("${now}")`, 'cancelled.equals(0)']
                } else if (val[0] === 'effective') {
                  return [`expire.ge("${now}")`, 'cancelled.equals(0)']
                } else if (val[0] === 'cancelled') {
                  return ['cancelled.equals(1)']
                }
              }
              return 'expire.gt("1970-01-01 00:00:00")'
            },
          },
          used_for: {
            label: this.$t('scope.text_779'),
            dropdown: true,
            items: [
              { label: this.$t('scope.commercial_evaluation'), key: 'test' },
              { label: this.$t('scope.community'), key: 'community' },
              { label: this.$t('scope.internal_test'), key: 'internal' },
              { label: this.$t('scope.commercial_license'), key: 'commercial' },
            ],
            filter: true,
            formatter: val => {
              return `used_for.in(${val})`
            },
          },
          licensor: {
            label: this.$t('common_610'),
            filter: true,
            formatter: val => {
              return `licensor.contains(${val})`
            },
          },
        },
      }),
      exportDataOptions: {
        items: [
          { label: this.$t('scope.text_318'), key: 'licensee' },
          { label: this.$t('scope.text_778'), key: 'service_num' },
          { label: this.$t('scope.text_779'), key: 'used_for' },
          { label: this.$t('scope.text_780'), key: 'expire' },
        ],
      },
      groupActions: [
        {
          label: this.$t('scope.text_781'),
          action: () => {
            const params = {
              title: this.$t('scope.text_781'),
              onManager: this.onManager,
            }
            if (this.getParams && this.getParams.customer_id) {
              params.customer_id = this.getParams.customer_id
            }
            this.createDialog('ApplyLicenseDialog', params)
          },
          meta: () => ({
            buttonType: 'primary',
          }),
        },
      ],
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = { ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams) }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'LicenseSidePage', {
        id: row.id,
        resource: 'licenserecords',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/less/theme';
  .status-success {
    color: @success-color;
  }
  .status-danger {
    color: @error-color;
  }
</style>
